const canUse = (function() {
  try {
    localStorage.setItem('saucey', 'test');
    localStorage.removeItem('saucey');
    return true;
  } catch (e) {
    return false;
  }
})();

const store = {
  get(key) {
    return canUse ? localStorage.getItem(key) : null;
  },

  set(key, value) {
    return canUse ? localStorage.setItem(key, value) : null;
  },

  remove(key) {
    return canUse ? localStorage.removeItem(key) : null;
  }
};

export default store;
